// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledLink from '../../../product/shared/components/labeled-link';
import LabeledString from '../../../shared/components/labeled-string';
import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import PartReturnStatus from './part-return-status';
import SmartFormLink from '../../../shared/components/smart-form-link/smart-form-link';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildDate} from '../../../shared/services/build-date';
import {buildDealer} from '../../../shared/services/build-dealer';
import {buildPartReturnString} from '../../../shared/services/build-part-return-string';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';
import {formatShipTo} from '../../shared/services/format-ship-to';
import {getRequestIcon} from '../../shared/services/get-request-icon';

const PartReturnListItem = props =>
    <li className='part-return-list-item'>
        <header>
            <a
                className='part-return-description'
                href={`#/part-requests/request-details/${props.item.rgaNumber}?&id=${props.item.id}`}
            >
                <div className={getRequestIcon(props.item.requestType.key)}/>
                <span>
                    {props.item.requestType.value} {props.item.stripLeadingZerosForRgaNumber()}
                </span>
            </a>
            {props.item.returnStatus.id === '1' &&
                <PartReturnStatus
                    className='part-return-status'
                    daysLeft={props.item.daysLeft}
                    isShipmentPriorityHigh={props.item.isShipmentPriorityHigh}
                />
            }
        </header>
        <div className='part-return-details'>
            <LabeledString
                data={buildDealer(props.item.account)}
                label='DEALER_LOCATION'
            />
            <LabeledString
                data={formatClaimNumber(props.item.claimNumber)}
                label='CLAIM'
            />
            <LabeledString
                data={buildPartReturnString(props.item)}
                label='PART'
            />
            <LabeledString
                data={props.item.reference1}
                label='WORK_ORDER'
            />
            <LabeledString
                data={props.item.dtac}
                label='DTAC_CASE'
            />
            <LabeledString
                data={props.item.returnStatus.description}
                label='STATUS'
            />
            <LabeledString
                data={buildDate(props.item.requestDate)}
                label='REQUESTED'
            />
            <LabeledString
                className={props.item.requestType.key === 'PART' ? '' : 'hidden'}
                data={formatShipTo(props.item.firstShipToLocation)}
                label='SHIP_TO'
            />
            <LabeledLink
                data={props.item.pin}
                href={`#/products/${props.item.pin}`}
                label='PIN'
            />
        </div>
        <footer>
            <SmartFormLink
                displayText='PRINT_TO_PDF'
                formName='RGA'
                icon={'PDF'}
                objectId={props.item.rgaNumber}
                showAsButton={true}
                showButtonIcon={true}
                translate={true}
            />
            <a
                className='button-primary'
                href={`#/part-requests/request-details/${props.item.rgaNumber}?&id=${props.item.id}`}
            >
                <FormattedMessage id='VIEW_DETAILS'/>
            </a>
        </footer>
    </li>;

PartReturnListItem.displayName = 'PartReturnListItem';
PartReturnListItem.propTypes = {
    item: PropTypes.instanceOf(PartReturn).isRequired
};
PartReturnListItem.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default PartReturnListItem;



// WEBPACK FOOTER //
// ./src/part-requests/shared/components/part-return-list-item.js